import React, { Component } from 'react';
import './styles.css';

class Input extends Component {
	render() {
		const { label, error } = this.props;

		return (
			<div className="container-form">
				<div className="form-input">
					<div>{label}</div>
					<input className={error ? 'input-error' : 'input'} {...this.props} />
				</div>
				{error && <span>{error}</span>}
			</div>
		);
	}
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input/index.js